export default __webpack_public_path__ + "static/media/headerEvents.6aa51fbd.jpg";